import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LocalSpinnerComponent } from './local-spinner.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LocalSpinnerComponent],
  exports: [LocalSpinnerComponent],
})
export class LocalSpinnerModule {}
